module.exports = __webpack_public_path__ + "static/media/good-morning-1.703cea60.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/facts/good-morning-1.jpg
// module id = 144
// module chunks = 0